import { jsx as _jsx } from "react/jsx-runtime";
import RecordColumn from '../record-column';
import RecordRow from '../record-row';
const displayHeader = ({ orientation, legend }) => (orientation === 'row' && legend) || (orientation === 'column' && !legend);
const displayValue = ({ legend }) => !legend;
const Record = ({ children, data, first = false, last = false, legend = false, orientation, }) => {
    const classNames = [
        'flex',
        'flex-1',
        'border-l',
        'border-l-record-border-color',
        'border-r',
        'border-r-record-border-color',
        'border-t-0',
        'border-b-0',
        'rounded-t-none',
        'rounded-bl-none',
    ];
    if (legend && orientation === 'column')
        classNames.push('hidden');
    if (orientation === 'column')
        classNames.push('flex-col');
    else if (orientation === 'row')
        classNames.push('flex-row');
    if (orientation === 'row') {
        classNames.push('!border-t');
        classNames.push('!border-t-record-border-color');
    }
    if ((last && !legend) || orientation === 'column') {
        classNames.push('!border-b');
        classNames.push('!border-b-record-border-color');
    }
    if ((first && legend) || orientation === 'column')
        classNames.push('!rounded-tl');
    if ((first && legend) || orientation === 'column')
        classNames.push('!rounded-tr');
    if ((last && !legend) || orientation === 'column')
        classNames.push('!rounded-bl');
    if ((last && !legend) || orientation === 'column')
        classNames.push('!rounded-br');
    if (orientation === 'column') {
        classNames.push('first:!mt-0');
        classNames.push('mt-2');
    }
    return (_jsx("div", { className: classNames.join(' '), children: _jsx(RecordRow, { orientation: orientation, children: data.map((datum) => (_jsx(RecordColumn, { first: first, last: last, legend: legend, orientation: orientation, width: datum.width || null, children: children(displayHeader({ orientation, legend }), displayValue({ legend }), datum, legend) }, datum.axis))) }) }));
};
export default Record;
